/* Imports */
import React from "react"
import { Table } from "fajny-react"
import { v4 as uuid } from "uuid"

import ComponentPage from "../../components/ComponentPage"
import SquareSpacer from "../../components/SquareSpacer"

import allSpacers from "../../data/all-spacers"

const SpacersPage = () => {
    return (
        <ComponentPage>
            <Table tableStyle="stripped" vAlign="middle">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Variable</th>
                        <th>CSS</th>
                        <th>Value</th>
                        <th>Demo</th>
                    </tr>
                </thead>

                <tbody>
                    {allSpacers.map(spacer => (
                        <tr key={uuid()}>
                            <td>Spacer {spacer.name}</td>
                            <td>{spacer.variable}</td>
                            <td>{spacer.css}</td>
                            <td>{spacer.value}px</td>
                            <td>
                                <SquareSpacer $height={spacer.value} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ComponentPage>
    )
}

export default SpacersPage
